export const PRICE_STATE_FROM = 'FROM' as const;
export type PRICE_STATE_FROM_TYPE = typeof PRICE_STATE_FROM;

export const PRICE_STATE_NOW_FROM = 'NOW_FROM' as const;
export type PRICE_STATE_NOW_FROM_TYPE = typeof PRICE_STATE_NOW_FROM;

export const PRICE_STATE_NOW = 'NOW' as const;
export type PRICE_STATE_NOW_TYPE = typeof PRICE_STATE_NOW;

export const PRICE_STATE_WAS = 'WAS' as const;
export type PRICE_STATE_WAS_TYPE = typeof PRICE_STATE_WAS;

export const PRICE_STATE_RRP = 'RRP' as const;
export type PRICE_STATE_RRP_TYPE = typeof PRICE_STATE_RRP;

export const PRICE_STATE_LOWEST = 'LOWEST' as const;
export type PRICE_STATE_LOWEST_TYPE = typeof PRICE_STATE_LOWEST;

export const PRICE_STATE_ORIGINAL = 'ORIGINAL' as const;
export type PRICE_STATE_ORIGINAL_TYPE = typeof PRICE_STATE_ORIGINAL;

export type PRICE_STATE =
  | PRICE_STATE_FROM_TYPE
  | PRICE_STATE_NOW_FROM_TYPE
  | PRICE_STATE_NOW_TYPE
  | PRICE_STATE_WAS_TYPE
  | PRICE_STATE_RRP_TYPE
  | PRICE_STATE_LOWEST_TYPE
  | PRICE_STATE_ORIGINAL_TYPE;

export const PRICE_TYPE_SELL = 'SELL' as const;
export type PRICE_TYPE_SELL_TYPE = typeof PRICE_TYPE_SELL;

export const PRICE_TYPE_STD = 'STD' as const;
export type PRICE_TYPE_STD_TYPE = typeof PRICE_TYPE_STD;

export const PRICE_TYPE_EM = 'EM' as const;
export type PRICE_TYPE_EM_TYPE = typeof PRICE_TYPE_EM;

export const PRICE_TYPE_RRP = 'RRP' as const;
export type PRICE_TYPE_RRP_TYPE = typeof PRICE_TYPE_RRP;

export const PRICE_TYPE_LOWEST = 'LOWEST' as const;
export type PRICE_TYPE_LOWEST_TYPE = typeof PRICE_TYPE_LOWEST;

export type PRICE_TYPE =
  | PRICE_TYPE_SELL_TYPE
  | PRICE_TYPE_STD_TYPE
  | PRICE_TYPE_EM_TYPE
  | PRICE_TYPE_RRP_TYPE
  | PRICE_TYPE_LOWEST_TYPE;
